module.exports = __webpack_public_path__ + "static/media/nova_sofiivka.9a14b813.jpg";